import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { HomeIcon, SchoolIcon, HeadphonesIcon, MessageSquareIcon, UserIcon } from 'lucide-react';
const tabs = [{
  to: '/',
  label: '首页',
  icon: HomeIcon,
  exact: true
}, {
  to: '/schools',
  label: '选校',
  icon: SchoolIcon
}, {
  to: '/tools',
  label: '1v1',
  icon: HeadphonesIcon,
  exact: true
}, {
  to: '/community',
  label: '社区',
  icon: MessageSquareIcon
}, {
  to: '/mine',
  label: '我的',
  icon: UserIcon
}];
export function BottomNav() {
  const {
    pathname
  } = useLocation();
  const isActive = (to: string, exact?: boolean) => exact ? pathname === to : pathname === to || pathname.startsWith(to + '/');
  return <nav role="navigation" aria-label="底部导航" className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[390px] bg-white border-t border-slate-100 z-40" style={{
    boxShadow: '0 -2px 12px rgba(0,0,0,0.04)'
  }} data-id="element-141">
      <div className="grid grid-cols-5 h-14" data-id="element-142">
        {tabs.map(t => {
        const Icon = t.icon;
        const active = isActive(t.to, t.exact);
        return <NavLink key={t.to} to={t.to} className="flex flex-col items-center justify-center gap-0.5" data-id="element-143">
              <Icon size={20} className={active ? 'text-blue-600' : 'text-slate-400'} strokeWidth={active ? 2.4 : 2} data-id="element-144" />
              <span className={`text-[11px] ${active ? 'text-blue-600 font-medium' : 'text-slate-500'}`} data-id="element-145">
                {t.label}
              </span>
            </NavLink>;
      })}
      </div>
    </nav>;
}